import { useIsAuthenticated, useMsal, useMsalAuthentication } from '@azure/msal-react'
import { InteractionStatus, InteractionType } from '@azure/msal-browser'
import { loginRequest } from '@/auth/msalConfig'
import { LoadingScreen } from '@/components/LoadingScreen/LoadingScreen'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export function ProtectedRoute({ children }: Props) {
  const isAuthenticated = useIsAuthenticated()
  const { inProgress } = useMsal()
  useMsalAuthentication(InteractionType.Redirect, loginRequest)

  if (inProgress !== InteractionStatus.None || !isAuthenticated) {
    return <LoadingScreen />
  }

  return <>{children}</>
}